import script from "./ConsumerSearchView.vue?vue&type=script&setup=true&lang=js"
export * from "./ConsumerSearchView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__